import { Component, OnDestroy, OnInit } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Observable, Subject } from 'rxjs';
import { AnalyticsService } from 'smartauction-frontend-micro-library';
import {
  DealerQuestionDto,
  InventoryService,
  LaunchDarklyService,
  QuestionsState,
  ResetSelectedQuestions
} from 'remarketing-angular-library';
import { ActivatedRoute } from '@angular/router';
import { InventoryItemDataService } from '../../../sell-shared/services/inventory-item-data.service';
import { QuestionComponent } from '../question/question.component';
import { AsyncPipe } from '@angular/common';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
    selector: 'sell-questions-shell',
    templateUrl: './questions-shell.component.html',
    styleUrls: ['./questions-shell.component.scss'],
    imports: [TranslocoDirective, QuestionComponent, AsyncPipe]
})
export class QuestionsShellComponent implements OnInit, OnDestroy {
  @Select(QuestionsState.questionsResponse) questionsResponse$: Observable<DealerQuestionDto[]>;
  destroyed$ = new Subject();

  constructor(
    private analyticsService: AnalyticsService,
    private store: Store,
    private route: ActivatedRoute,
    private inventoryItemDataService: InventoryItemDataService
  ) {}

  ngOnInit() {
    this.inventoryItemDataService.fetchBasicDetails();
    setTimeout(() => {
      this.analyticsService.trackPageLoad({
        page: {
          pageName: `${this.analyticsService.digitalData.page.category.site}:Sell:Manage:Questions`,
          section: 'Sell',
          site: this.analyticsService.digitalData.page.category.site,
          subsection: 'Manage',
          title: 'Questions',
          data: {
            vehicleList: this.route.snapshot.parent ? this.route.snapshot.parent.paramMap.get('inventoryItemUuid') : ''
          }
        }
      });
    }, 200);
  }

  ngOnDestroy() {
    this.store.dispatch(new ResetSelectedQuestions());
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
